// resources/js/components/StartpageContent.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '/css/app.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import p_hongkongcity from '/images/HK_Bild_AdobeStock_116977445.webp';

import p_Lukas from '/images/Lukas_Will_4.webp';
import p_Jacqueline from '/images/Bigwood_Jacqueline_02.webp';

import p_schuetteValues from '/images/Schuette_grau_Values.webp';
import p_schuetteMission from '/images/Schuette_grau_Mission.webp';
import p_schuetteVision from '/images/Schuette_grau_Vision.webp';

export default function AboutContent() {
    return (
        <div className="row d-flex justify-content-center">
            <div className="col-md-9">
                <div>
                    <h1 className="text-center mt-3">About us</h1>
                </div>
                <div className='fs-7'>
                    <p>
                    {/* <FontAwesomeIcon icon="fa-solid fa-caret-right" className="me-2"/> */}
                        We are the world leading experts in low-cost displays. A combination of Chinese spirit and German workmanship makes the perfect relationship to provide our customers with the best all round products and service.
                    </p>
                    <p>
                    {/* <FontAwesomeIcon icon="fa-solid fa-caret-right" className="me-2"/> */}
                        Welcome to J. E. Schum (Asia) Ltd. – A buying organization, owned by a German Company J. E. Schum GmbH & Co. KG, in Asia. Our mother company was established in 1877 and has over 140 years’ experience.
                    </p>
                    <p>
                        With our offices in Hong Kong and Hangzhou we have direct access to and control over the supply market for the low-cost products and displays.
                    </p>
                    <p>
                        With our tried and tested small-price-concepts, our customers are secure in the knowledge that all financial and planning aspects are efficiently managed.
                    </p>
                    <p>
                        We strive to develop our suppliers into long-term value-partnerships, to achieve sustained growth which ultimately benefits our customers.
                    </p>
                    <p>
                        About your supporting team in detail:
                    </p>
                </div>
                <div className="fs-7 mb-2 row justify-content-center">
                    <div className="col-sm-6 px-sm-2 my-2 px-0 lukas-card">
                        <div className="card">
                            <div className="row w-100">
                                <div className="col-xxl-4">
                                    <img src={p_Lukas} alt="Contact Lukas Will" className="my-2 mx-2 align-self-start aboutus_contactPicture img-fluid w-100"/>
                                </div>
                                <div className="col-xxl-8">
                                    <div className="card-body text-nowrap">
                                        <div className="card-title mx-2 schum-color fw-bold">
                                            Mr. Lukas Will
                                        </div>
                                        <div className="card-subtitle mx-2 schum-color">
                                            Operations Manager
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Mail: <a href="mailto:l.will@schum.de" className="text-decoration-none">l.will@schum.de</a>
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Phone: <a href="phone:+4993120012858" className="text-decoration-none">+49 (931) 20012-858</a>
                                        </div>
                                        <div className="card-subtitle mx-2 mb-1">
                                            Mobile: <a href="phone:+4915255247613" className="text-decoration-none">+49 (0) 1525 5247613</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="row w-100 ps-2">
                                <p className="card-text mb-2">
                                    Lukas joined the group in 2019. He has tremendous operational experience and is always on hand to advise and help. 
                                    Master of getting things done!
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 px-sm-2 my-2 px-0">
                        <div className="card">
                            <div className="row w-100">
                                <div className="col-xxl-4">
                                    <img src={p_Jacqueline} alt="Contact Jacqueline Bigwood" className="my-2 mx-2 align-self-start aboutus_contactPicture img-fluid w-100"/>
                                </div>
                                <div className="col-xxl-8">
                                    <div className="card-body text-nowrap">
                                        <div className="card-title mx-2 schum-color fw-bold">
                                            Ms. Jacqueline Bigwood
                                        </div>
                                        <div className="card-subtitle mx-2 schum-color">
                                            Sales Development Manager
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Mail: <a href="mailto:j.bigwood@schum.de" className="text-decoration-none">j.bigwood@schum.de</a>
                                        </div>
                                        <div className="card-subtitle mx-2">
                                            Phone: <a href="phone:+4993120012847" className="text-decoration-none">+49 (931) 20012-847</a>
                                        </div>
                                        <div className="card-subtitle mx-2 mb-1">
                                            Mobile: <a href="phone:+491726724596" className="text-decoration-none">+49 (0) 172 6724596</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="row w-100 ps-2">
                                <p className="card-text mb-2">
                                    Jacqueline is the newest member of the team and has considerable experience and knowledge of international business and development. 
                                    She always likes to keep customers and partners happy and is the creative one! Always finds solutions!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" fs-7">
                    <div className="d-flex flex-row my-3">
                        <img src={p_schuetteVision} alt="Vision" className="aboutus_schuette me-3"/>
                        <div className="align-self-center">Is to build lasting retail and wholesale partnerships by delivering industry leading display solutions.</div>
                    </div>
                    <div className="d-flex flex-row my-3 ms-md-5">
                        <img src={p_schuetteMission} alt="Mission" className="aboutus_schuette me-3"/>
                        <div className="align-self-center">With passionate teams, we drive to ensure customers benefit from our innovative business style and expertise.</div>
                    </div>
                    <div className="d-flex flex-row my-3 ms-md-8">
                        <img src={p_schuetteValues} alt="Values" className="aboutus_schuette me-3"/>
                        <div className="align-self-top">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="p-2 fw-bold">Respect</td>
                                        <td className="p-2">Treat everyone with respect and accept we are all different, making the world a fun place to be.</td>
                                    </tr>
                                    <tr>
                                        <td className="p-2 fw-bold">People</td>
                                        <td className="p-2">Appreciate we all have something to add, be open and always listen.</td>
                                    </tr>
                                    <tr>
                                        <td className="p-2 fw-bold">Partnerships</td>
                                        <td className="p-2">Committed to develop long last partnerships, work together to create benefits for all.</td>
                                    </tr>
                                    <tr>
                                        <td className="p-2 fw-bold">Innovation</td>
                                        <td className="p-2">Be creative with new solutions, products and concepts. Bringing unique ideas into reality.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="my-3">
                    <img src={p_hongkongcity} alt="city of Hong Kong" className="w-100"/>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('about-content')) {
    const container = document.getElementById('about-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<AboutContent />);
}